import React, { useState } from 'react';
import LaboratoryRequestCreateForm, {
	LaboratoryRequestFormDataScheme,
} from '../../LaboratoryRequestCreate/LaboratoryRequestCreateForm';
import LaboratoryRequestTemplateNameForm from '../LaboratoryRequestTemplateName/LaboratoryRequestTemplateNameForm';
import {
	LaboratoryRequisitionTemplate,
	useUpdateLaboratoryRequisitionTemplateMutation,
} from '../../../../../graphql/graphql';
import { Size } from '../../../../../Enums/Size.enum';
import useApiClient from '../../../../Base/Hooks/useApiClient';

interface Props {
	item: LaboratoryRequisitionTemplate;
	changeModalSize: (size: Size) => void;
	onUpdate: (item: LaboratoryRequisitionTemplate) => void;
	workplaceId: string;
}

enum LaboratoryRequestTemplateEditStatus {
	REQUEST_FILL = 'form_fill',
	TEMPLATE_NAME = 'template_name',
}

const LaboratoryRequestTemplateEdit: React.FC<Props> = ({
	item,
	changeModalSize,
	onUpdate,
	workplaceId,
}) => {
	const [state, setState] = useState<LaboratoryRequestTemplateEditStatus>(
		LaboratoryRequestTemplateEditStatus.REQUEST_FILL,
	);
	const [formData, setFormData] = useState<
		LaboratoryRequestFormDataScheme[] | undefined
	>(undefined);
	const [updateLaboratoryTemplate] =
		useUpdateLaboratoryRequisitionTemplateMutation();
	const { displayGQLError, displayError } = useApiClient();

	const formDataSuccess = (values: LaboratoryRequestFormDataScheme[]) => {
		setFormData(values);
		setState(LaboratoryRequestTemplateEditStatus.TEMPLATE_NAME);
		changeModalSize(Size.MD);
	};

	const handleUpdate = async (name: string) => {
		try {
			const data = await updateLaboratoryTemplate({
				where: { id: item.id },
				input: {
					name,
					data: {
						values: formData,
					},
				},
			}).unwrap();
			displayGQLError(data);
			if (data.updateLaboratoryRequisitionTemplate) {
				onUpdate(
					data.updateLaboratoryRequisitionTemplate as LaboratoryRequisitionTemplate,
				);
			}
		} catch (e) {
			displayError(e);
		}
	};

	switch (state) {
		case LaboratoryRequestTemplateEditStatus.REQUEST_FILL:
			return (
				<LaboratoryRequestCreateForm
					onSuccess={formDataSuccess}
					formId={item.laboratoryRequisitionId}
					defaultValues={item.data.values}
					workplaceId={workplaceId}
				/>
			);
		case LaboratoryRequestTemplateEditStatus.TEMPLATE_NAME:
			return (
				<LaboratoryRequestTemplateNameForm
					onSuccess={handleUpdate}
					defaultValues={{ name: item.name! }}
				/>
			);
	}
};

export default LaboratoryRequestTemplateEdit;
